import {colors} from '../../colors/colors';

export function getActiveColor(variant?: 'default' | 'ai'): string {
    if (variant === 'ai') {
        return colors.aiPurplePrimary;
    }

    return colors.blue;
}
